import {
    GET_ALL_SCHEDULED,
    ACTION_SCHEDULED_FASTFORWARD,
    ACTION_SCHEDULED_CONFIRMATION,
    UPDATE_SCHEDULED_ORDERS,
    ACTION_SCHEDULED_CLEAN
} from '../constants';

export const getAllScheduled = (scheduleds) => ({
    type: GET_ALL_SCHEDULED,
    scheduleds
});

export const onClickScheduledFastForward = (scheduled) => ({
    type: ACTION_SCHEDULED_FASTFORWARD,
    scheduled
});

export const scheduledClean = () => ({
    type: ACTION_SCHEDULED_CLEAN,
});

export const onClickScheduledConfirmation = (scheduled) => ({
    type: ACTION_SCHEDULED_CONFIRMATION,
    scheduled
});

export const updatedScheduledOrders = (updatedOrders, orders) => ({
    type: UPDATE_SCHEDULED_ORDERS,
    updatedOrders,
    orders
});